import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "person-panel-list__empty"
}
const _hoisted_2 = { class: "person-panel-list__count" }
const _hoisted_3 = { class: "person-panel-list__count-number" }
const _hoisted_4 = { class: "person-panel-list__group-name" }
const _hoisted_5 = {
  key: 0,
  class: "person-panel-list__partial"
}
const _hoisted_6 = {
  key: 1,
  class: "person-panel-list__end"
}

import {
	computed,
	onBeforeUnmount,
	onMounted,
	ref, watch
} from "vue";
import ClientsPanelListItem from "@/components/main/clients-panel/ClientsPanelListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppScrollTopButton from "@/components/ui-kit/button/AppScrollTopButton.vue";
import { useScrollTopButton } from "@/composables/useScrollTopButton";
import {projectPageStore} from "@/store/project-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectsBlockPanelList',
  props: {
    searchText: {}
  },
  emits: ["on-get-partial"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const projectStore = projectPageStore()
const $personPanelList = ref<HTMLDivElement | null>(null)

const isLoadingAll = computed(() => projectStore.projectContactsLoading);
const isLoadingPartial = computed(() => projectStore.projectContactsPartialLoading);
const canLoadNext = computed(() => projectStore.canLoadNextProjectContacts);
const clients = computed(() => projectStore.projectContacts);

const loadedCount = computed(() => {
	const groups = (clients.value as unknown as { Groups?: { Persons?: unknown[] }[] } | null)?.Groups ?? []
	return groups.reduce((acc, group) => acc + (group.Persons?.length ?? 0), 0)
});

const isEmpty = computed(() => !isLoadingAll.value && loadedCount.value === 0);

const { isScrollTopEnabled, scrollToTop } = useScrollTopButton(
	$personPanelList,
	'[data-contact-id]',
	() => clients.value
)

const onScroll = () => {
	if (!$personPanelList.value) return

	if (
		!projectStore.projectContactsLoading
		&& !projectStore.projectContactsPartialLoading
		&& projectStore.canLoadNextProjectContacts
		&& $personPanelList.value.scrollTop + $personPanelList.value.offsetHeight > $personPanelList.value.scrollHeight - 1000
	) {
		emit('on-get-partial')
	}
}

onMounted(() => {
	$personPanelList.value?.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
	$personPanelList.value?.removeEventListener('scroll', onScroll)
})

watch(isLoadingAll, (newVal) => {
	if (newVal) {
		$personPanelList.value!.scrollTop = 0
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const partialLoaderStyle = computed(() => ({
	position: 'relative',
	height: '32px',
	'background-color': 'transparent'
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "person-panel-list",
    ref_key: "$personPanelList",
    ref: $personPanelList
  }, [
    (isLoadingAll.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    (isEmpty.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('contacts_empty')), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t('contacts_found')) + ": ", 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(clients.value?.Count || 0), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value?.Groups, (group) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "person-panel-list__group",
              key: group.Id
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(group.Name) + ": ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Persons, (contact) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: contact.Id
                }, [
                  _createVNode(ClientsPanelListItem, {
                    client: contact,
                    "search-text": props.searchText
                  }, null, 8, ["client", "search-text"]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "person-panel-list__divider" }, null, -1))
                ], 64))
              }), 128))
            ]))
          }), 128)),
          (!isLoadingAll.value && isLoadingPartial.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(AppLoader, {
                  style: _normalizeStyle(partialLoaderStyle.value)
                }, null, 8, ["style"])
              ]))
            : (!isLoadingAll.value && !canLoadNext.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('contacts_all_loaded')), 1))
              : _createCommentVNode("", true)
        ], 64)),
    _createVNode(AppScrollTopButton, {
      enabled: _unref(isScrollTopEnabled),
      onOnClick: _unref(scrollToTop)
    }, null, 8, ["enabled", "onOnClick"])
  ], 512))
}
}

})